import { FC, useRef, useState } from "react";
import {
  Container,
  Box,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { SliderStyle } from "../Styles/LandingStyles";
import slider1 from "../../assets/images/slider-1.png";
import slider2 from "../../assets/images/slider-2.png";
import slider3 from "../../assets/images/slider-3.png";
import Sliders from "react-slick";
import theme from "../../helpers/theme";
import { FaPlayCircle } from "react-icons/fa";

const Slider: FC = () => {
  const sliderRef = useRef<any>(null);
  const classes = SliderStyle();
  const isActive = useMediaQuery(theme.breakpoints.down("md"));

  const [currentSlide, setCurrentSlide] = useState<any>(0);

  const settings = {
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    speed: 1000,
    fade: true,
    easing: "ease",
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
        },
      },
    ],
    afterChange: (current: number) => setCurrentSlide(current),
  };

  const slides = [
    {
      title: "Discover",
      description:
        "Get started easily and access refundable opportunities today.",
      image: slider1,
      link: "https://youtu.be/n4hSKZqwsD0",
    },
    {
      title: "Learn",
      description:
        "Invest confidently with explanatory videos and step-by-step guidance.",
      image: slider2,
      link: "https://www.youtube.com/watch?v=UF42JHS-eFA",
    },
    {
      title: "Invest",
      description:
        "Browse through our projects and get started investing today.",
      image: slider3,
    },
  ];

  const handleTitleClick = (index: number) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };

  const handleImageClick = () => {
    const slide = slides[currentSlide];
    if (slide.link && slide.link !== "") {
      window.open(slide.link, "_blank");
    }
  };

  return (
    <div>
      <Box
        data-aos="fade-up"
        data-aos-duration="1200"
        component="section"
        style={{ marginTop: "50px" }}
      >
        <Container fixed>
          <Grid item>
            <Box textAlign="center" mt={10} mb={isActive ? "1.5rem" : 0}>
              <Typography color="primary">
                <Typography
                  className="aspekta-semiBold hero-blue"
                  style={{ fontSize: isActive ? "28px" : "40px" }}
                >
                  Get started in 3 steps
                </Typography>
                <br />
              </Typography>
            </Box>
          </Grid>

          {/* Slider Content */}
          <Grid item>
            <Sliders ref={sliderRef} className="vslider" {...settings}>
              {slides.map((slide, index) => (
                <Box key={index} className="slide-content">
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: isActive ? "column-reverse" : "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    spacing={2}
                  >
                    <Grid item lg={5}>
                      {slides.map((s, i) => (
                        <Box
                          key={i}
                          position={"relative"}
                          paddingLeft="4rem"
                          marginTop={i > 0 ? "1rem" : "0"}
                          onClick={() => handleTitleClick(i)}
                          style={{ cursor: "pointer" }}
                        >
                          <Box
                            className={
                              i === index ? classes.activeDot : classes.dot
                            }
                          />
                          <h5
                            className="aspekta-semiBold hero-blue"
                            style={{ fontSize: isActive ? "28px" : "32px" }}
                          >
                            {s.title}
                          </h5>
                          {i === index && (
                            <Typography className={classes.slideText}>
                              {s.description}
                            </Typography>
                          )}
                        </Box>
                      ))}
                    </Grid>
                    <Grid item lg={7} style={{ position: "relative" }}>
                      <img
                        className="img-fluid"
                        src={slide.image}
                        alt={slide.title}
                        onClick={(e) => handleImageClick()}
                        style={{ cursor: "pointer" }}
                      />
                      {slide.link && slide.link !== "" && (
                        <Box
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                        >
                          <FaPlayCircle
                            style={{
                              fontSize: "72px",
                              color: "#fff",
                              backgroundColor: "rgba(0, 0, 0, 0.8)",
                              borderRadius: "50%",
                              pointerEvents: "none",
                            }}
                          />
                        </Box>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              ))}
            </Sliders>
          </Grid>

        </Container>
      </Box>
    </div>
  );
};

export default Slider;
